<template>
  <pt-download-the-form class="pt-download-the-form__withData" @getMrTableDownload="getMrTableDownload"
  @getInOutTableDownload="getInOutTableDownload"></pt-download-the-form>
</template>

<script>
import PtDownloadTheForm from './index'
export default {
  name: 'pt-download-the-form__withData',
  components: {
    'pt-download-the-form': PtDownloadTheForm
  },
  methods: {
    getMrTableDownload (data) {
      data=data||{}
      this.$store.dispatch('getMrTableDownload', data).then(res => {
        this.$message.success('核磁表格下载成功,请前往下载导出下载')
      }).catch(err => {
        this.$message.error(err || '核磁表格下载失败')
      })
    },
    getInOutTableDownload (data) {
      data = data || {}
      this.$store.dispatch('getInOutTableDownload', data).then(res => {
        this.$message.success('出入库表格下载成功,请前往下载导出下载')
      }).catch(err => {
        this.$message.error(err || '出入库表格下载失败')
      })

    }
  }
}
</script>
